import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { NAV } from "@/constants/testIds";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import MobileMenu, { MobileMenuToggle } from "@/components/nav/MobileMenu";
import { useScrolled } from "@/hooks/useScrolled";

const LINKS = [
  { to: "/", label: "Inicio", id: NAV.linkHome },
  { to: "/historia", label: "Historia", id: NAV.linkHistoria },
  { to: "/herramientas", label: "Herramientas", id: NAV.linkHerramientas },
  { to: "/contacto", label: "Contacto", id: NAV.linkContacto },
];

const DesktopNav = ({ pathname }) => (
  <nav className="hidden lg:flex items-center gap-10">
    {LINKS.map((l) => (
      <Link
        key={l.to}
        to={l.to}
        data-testid={l.id}
        className={`link-underline font-sans text-[13px] tracking-[0.14em] uppercase transition-colors ${
          pathname === l.to
            ? "text-razmek-blue"
            : "text-razmek-dark hover:text-razmek-blue"
        }`}
      >
        {l.label}
      </Link>
    ))}
  </nav>
);

const Navbar = () => {
  const scrolled = useScrolled(16);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // Close mobile menu on route change
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const toggleOpen = useCallback(() => setOpen((v) => !v), []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/85 border-b border-razmek"
          : "bg-white/0"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="h-20 flex items-center justify-between">
          <Link to="/" data-testid={NAV.logo} className="flex items-center">
            <Logo />
          </Link>

          <DesktopNav pathname={pathname} />

          <div className="flex items-center gap-3">
            <Link to="/precalificacion" className="hidden md:block">
              <Button
                data-testid={NAV.ctaPrecalificacion}
                className="bg-razmek-blue hover:bg-razmek-dark text-white rounded-none border-2 border-razmek-blue hover:border-razmek-gold transition-all font-sans tracking-[0.14em] uppercase text-[11px] px-6 py-5"
              >
                Agendar asesoría
              </Button>
            </Link>
            <MobileMenuToggle
              open={open}
              onToggle={toggleOpen}
              testId={NAV.mobileToggle}
            />
          </div>
        </div>
      </div>

      <MobileMenu open={open} links={LINKS} />
    </header>
  );
};

export default Navbar;
